module.exports = __webpack_public_path__ + "static/media/pod.da8ebe42.png";